import { schema } from 'normalizr';

export const documentSchema = new schema.Entity('documents', {}, { idAttribute: 'DocumentId' });
